<div class="crosstalk-checkbox">
    <cc-checkbox
        *ngIf="renderCheckbox"
        [(value)]="value"
        (valueChange)="onClick($event)">
    </cc-checkbox>
</div>
